import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { JOURNEY } from "./data";
import { SectionHeading } from "./Services";
import { scrollToSection } from "@/lib/scrollTo";

export const Journey = () => (
  <section id="process" className="border-y border-[#D4AF37]/10 bg-[#F3EEE2]" data-testid="journey-section">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
      <SectionHeading id="process" overline="The Student Journey" title="From brief to brilliant," accent="in five steps." />
      <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:grid-cols-5 lg:gap-6">
        {JOURNEY.map((step, i) => (
          <motion.div
            key={step.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.33, 1, 0.68, 1] }}
            className="relative border-l-2 border-[#D4AF37]/25 pl-6 lg:border-l-0 lg:pl-0 lg:pt-8"
            data-testid={`journey-step-${step.num}`}
          >
            <span className="absolute -left-[5px] top-1 h-2 w-2 rotate-45 bg-[#D4AF37] lg:hidden" />
            <span className="mb-6 hidden h-px w-full bg-[#D4AF37]/25 lg:block" />
            <p className="font-serif-display text-5xl font-light text-[#A07E1F]/40">{step.num}</p>
            <h3 className="mt-3 font-serif-display text-xl font-semibold text-[#12294D] sm:text-2xl">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#46586F]">{step.desc}</p>
          </motion.div>
        ))}
      </div>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.4 }}
        className="mt-16 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
      >
        <button
          onClick={() => scrollToSection("#upload-brief")}
          data-testid="journey-start-button"
          className="group flex items-center gap-3 rounded-full bg-[#D4AF37] px-8 py-4 font-mono-accent text-xs font-bold uppercase tracking-[0.18em] text-[#0A1E3C] transition-colors duration-300 hover:bg-[#C9A227]"
        >
          Start Step One — Share Your Brief
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
        <p className="text-sm text-[#5E6E85]">Quotes in under 15 minutes. No obligation.</p>
      </motion.div>
    </div>
  </section>
);
